import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-alarms-active-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      @if (loading()) {
        <div class="text-center py-8 text-neutral-6">
          {{ t('ALARMS.ACTIVE_TABLE.NO_ACTIVE_ALARMS') }}
        </div>
      } @else {
        @if (rows().length === 0) {
          <div class="text-center py-8 text-neutral-6">
            {{ t('ALARMS.ACTIVE_TABLE.NO_ACTIVE_ALARMS') }}
          </div>
        } @else {
          <div class="overflow-x-auto">
            <table class="min-w-full border-collapse">
              <thead>
                <tr class="text-center text-md text-neutral-8">
                  <th class="py-2 px-1 w-full text-left"></th>
                  @for (col of columns(); track col) {
                    <th class="py-2 px-2 w-16 font-medium">{{ col }}</th>
                  }
                </tr>
              </thead>
              <tbody class="text-md text-neutral-10">
                @for (row of rows(); track row.name) {
                  <tr>
                    <td class="py-2 border-b border-[#F0F0F0] text-left">
                      {{ row.name }}
                    </td>
                    @for (value of row.values; let i = $index; track i) {
                      <td
                        [class]="getCellClass(i)"
                        class="py-2 border-b border-[#F0F0F0] text-center"
                      >
                        {{ value }}
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </ng-container>
  `,
})
export class AlarmsActiveTableComponent {
  columns = input<string[]>([]);
  rows = input<{name:string,values:number[]}[]>([]);
  loading = input<boolean>(true)

  /**
   * Returns the appropriate CSS class for a cell based on the column index.
   * @param index Index of the column.
   * @returns CSS class for the column.
   */
  getCellClass(index: number): string {
    const classes = ['text-error', 'text-quaternary', 'text-quinary'];
    return classes[index] || '';
  }
}
